import React from 'react';
import { Menu, MenuItem, ListItemText } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStyles } from '../styles';
import { SortType } from '../types';

interface SortMenuProps {
  anchorEl: null | HTMLElement;
  onClose: () => void;
  onSortChange: (sortType: SortType) => void;
  currentSort?: SortType;
}

export const SortMenu: React.FC<SortMenuProps> = ({ anchorEl, onClose, onSortChange, currentSort }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const handleSortChange = (sortType: SortType) => {
    onSortChange(sortType);
    onClose();
  };

  const sortOptions = [
    { value: SortType.NAME_ASC, key: 'name-asc', label: t('courses.sort.nameAtoZ') },
    { value: SortType.NAME_DESC, key: 'name-desc', label: t('courses.sort.nameZtoA') },
    {
      value: SortType.COMPLETION_DATE_ASC,
      key: 'completion-date-asc',
      label: t('courses.sort.completionDateOldToNew'),
    },
    {
      value: SortType.COMPLETION_DATE_DESC,
      key: 'completion-date-desc',
      label: t('courses.sort.completionDateNewToOld'),
    },
    {
      value: SortType.EXPIRATION_DATE_ASC,
      key: 'expiration-date-asc',
      label: t('courses.sort.expirationDateOldToNew'),
    },
    {
      value: SortType.EXPIRATION_DATE_DESC,
      key: 'expiration-date-desc',
      label: t('courses.sort.expirationDateNewToOld'),
    },
  ];

  return (
    <Menu
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={onClose}
      className={classes.sortMenu}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      {sortOptions.map(option => (
        <MenuItem
          key={option.value}
          data-testid={`courses-sort-${option.key}`}
          onClick={() => handleSortChange(option.value)}
          className={classes.menuItem}
          selected={currentSort === option.value}
        >
          <ListItemText>{option.label}</ListItemText>
        </MenuItem>
      ))}
    </Menu>
  );
};
